import { useLang } from "../context/LanguageContext";
import { FadeUp } from "./Reveal";

const FLEET = [
  {
    url: "https://images.unsplash.com/photo-1750210505997-ed85e9f8cb12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHw0fHxtZXJjZWRlcyUyMHYlMjBjbGFzcyUyMGJsYWNrJTIwdmlwJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg0ODM0NTEwfDA&ixlib=rb-4.1.0&q=85",
    label: "Mercedes V-Class VIP",
    span: "md:col-span-8 aspect-[16/10]",
  },
  {
    url: "https://images.unsplash.com/photo-1678707407526-06201ed279e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHxtZXJjZWRlcyUyMHYlMjBjbGFzcyUyMGJsYWNrJTIwdmlwJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg0ODM0NTEwfDA&ixlib=rb-4.1.0&q=85",
    label: "Premium Leather",
    span: "md:col-span-4 aspect-[3/4]",
  },
  {
    url: "https://images.pexels.com/photos/14909610/pexels-photo-14909610.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    label: "Kyrenia Marina",
    span: "md:col-span-4 aspect-[3/4]",
  },
  {
    url: "https://images.unsplash.com/photo-1764605206511-7a649d9df63b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBibGFjayUyMHNlZGFuJTIwbmlnaHQlMjBkcml2aW5nfGVufDB8fHx8MTc4NDgzNDUwOXww&ixlib=rb-4.1.0&q=85",
    label: "Black Sedan · Night",
    span: "md:col-span-8 aspect-[16/10]",
  },
];

export const Fleet = () => {
  const { t } = useLang();
  return (
    <section id="fleet" className="relative py-24 md:py-40 bg-[#050505]" data-testid="fleet-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-16 md:mb-24">
          <div className="md:col-span-8">
            <FadeUp>
              <p className="font-mono text-xs tracking-[0.3em] text-[#d4af37] mb-6">{t.fleet.overline}</p>
              <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white leading-tight">
                {t.fleet.title}
              </h2>
            </FadeUp>
          </div>
          <div className="md:col-span-4">
            <FadeUp delay={0.1}>
              <p className="font-sans text-base text-white/60 leading-relaxed">{t.fleet.desc}</p>
            </FadeUp>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
          {FLEET.map((f, i) => (
            <FadeUp key={i} delay={i * 0.08} className={f.span}>
              <div className="img-zoom-parent group relative overflow-hidden border border-white/10 h-full">
                <img src={f.url} alt={f.label} className="img-zoom w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
                <span className="absolute bottom-6 left-6 font-mono text-xs tracking-[0.2em] text-white/80 uppercase">
                  {f.label}
                </span>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
